import { useCallback } from "react";
import { ComputerUsersPublishersAppsMembership, Folders, ProfilePrivilege, ResourceAPP, URLControl, User } from "./resourceInterface";
import { debounce } from "../../../services/Helpers";

export const mapUser = (user: any): User => {
  return {
    id: user.id,
    domainName: user.domainName,
    cn: user.cn,
    email: user.email,
    firstName: user.firstName,
    lastName: user.lastName,
    computerId: user.computerId,
    belongsToComputerId: user.belongsToComputerId,
    loginStatus: user.loginStatus,
    currentLoginTime: user.currentLoginTime,
    lastLoginTime: user.lastLoginTime,
    role: user.role,
    whiteswanRole: user.whiteswanRole,
    whiteswanRoleId: user.whiteswanRoleId,
    suspiciousAccount: user.suspiciousAccount,
    privileged: user.privileged,
    createdAt: user.createdAt,
    isInvitedUser: user.isInvitedUser,
    isAdUser: user.isAdUser,
    adUserId: user.adUserId,
    publishedRoles: user.publishedRoles || [],
    isVerificationRequired: user.isVerificationRequired,
    ssoSource: user.ssoSource,
    connectionMode: user.connectionMode,
    enabled: user.enabled,
    username: user.username,
    password: user.password,
    authorities: user.authorities || [],
    accountNonExpired: user.accountNonExpired,
    accountNonLocked: user.accountNonLocked,
    credentialsNonExpired: user.credentialsNonExpired,
  };
};



export const getInheritedEndpointResourceStatusValue = (app: ResourceAPP | null, getData: string) => {
  if (!app || !app[getData]) return "";

  const resource = app[getData];

  const groupStatus: Record<"ENABLED" | "DISABLED" | "DYNAMIC", string> = {
    ENABLED: "ALLOWED",
    DISABLED: "DENIED",
    DYNAMIC: "TIMED",
  };
  if (!resource?.inheritedGroupStatus) {
    const groupStatusKey = resource.groupStatus as "ENABLED" | "DISABLED" | "DYNAMIC";
    return `(${groupStatus[groupStatusKey]})`;
  }

  const inheritedKey = resource.inheritedGroupStatus as "ENABLED" | "DISABLED" | "DYNAMIC";

  return `(${groupStatus[inheritedKey]})`;

};



export const getInheritedEndpointResourceStatusValueForProfilePrivilege = (app: ProfilePrivilege | null) => {

  const groupStatus: Record<"ENABLED" | "DISABLED" | "DYNAMIC" | "TIMED", string> = {
    ENABLED: "ALLOWED",
    DISABLED: "DENIED",
    DYNAMIC: "TIMED",
    TIMED: "TIMED"
  };


  if (!app?.inheritedGroupStatus) {
    const groupStatusKey = app?.profileResource as "ENABLED" | "DISABLED" | "DYNAMIC" | "TIMED";
    return `(${groupStatus[groupStatusKey]})`;
  }

  const inheritedKey = app.inheritedGroupStatus as "ENABLED" | "DISABLED" | "DYNAMIC" | "TIMED";

  return `(${groupStatus[inheritedKey]})`;

};


export const getInheritedEndpointResourceStatusValueForURL = (app: URLControl | null) => {
  const groupStatusMap: Record<"ENABLED" | "DISABLED" | "DYNAMIC", string> = {
    ENABLED: "ALLOWED",
    DISABLED: "DENIED",
    DYNAMIC: "TIMED",
  };

  if (!app) return "";

  const key: "ENABLED" | "DISABLED" | "DYNAMIC" | string =
    app.inheritedGroupStatus || app.groupStatus || app.profileResource || "";

  const mappedStatus = (groupStatusMap as Record<string, string>)[key] || key;

  return `(${mappedStatus})`;
};


export const getInheritedEndpointResourceStatusValueForFolders = (app: Folders | null) => {

  const groupStatus: Record<"ENABLED" | "DISABLED" | "DYNAMIC", string> = {
    ENABLED: "ALLOWED",
    DISABLED: "DENIED",
    DYNAMIC: "TIMED",
  };

  if (!app?.inheritedGroupStatus) {
    const groupStatusKey = app?.groupStatus as "ENABLED" | "DISABLED" | "DYNAMIC";
    return `(${groupStatus[groupStatusKey]})`;
  }

  const inheritedKey = app?.inheritedGroupStatus as "ENABLED" | "DISABLED" | "DYNAMIC";

  return `(${groupStatus[inheritedKey]})`;

};


export const getTimerDisplay = (remainingTime: number) => {
  const totalSeconds = Number(remainingTime);
  if (!Number.isFinite(totalSeconds) || totalSeconds <= 0) return "0m";

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  return hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;
};


export const mapUserGroupsToProfilePrivileges = (responses: any[]): ProfilePrivilege[] => {
  if (!responses || !Array.isArray(responses)) return [];

  return responses.map((response) => {
    const group = response.adComputerUserGroup || {};

    return {
      profileId: response.adComputerUser?.defaultProfileId || 0,
      groupId: group.id || 0,
      profileName: group.cn || "",
      cn: group.cn || "",
      type: "GROUP",
      profileResource: response.groupStatus,
      trustLevel: null,
      categoryName: group.categories?.[0] || null,
      reputationScore: group.reputationScore || 0,
      inheritedGroupStatus: response.inheritedGroupStatus || null
    };
  });
};

export const labelMapping = (
  label: string,
  value: string
): "ALLOWED" | "DENIED" | "TIMED" | string => {
  switch (label.toLowerCase()) {
    case "enabled":
      return "ALLOWED";
    case "disabled":
    case "blocked":
      return "DENIED";
    case "dynamic":
    case "timed":
      return "TIMED";
    default:
      return value.length > 0 ? value.replace(/[()]/g, "") : "INHERITED";
  }
};






